import mixpanel, { type OverridedMixpanel } from 'mixpanel-browser';

export default mixpanel;
export type { OverridedMixpanel };
